import { render } from "./CardInfo.vue?vue&type=template&id=8ba67392&scoped=true"
import script from "./CardInfo.vue?vue&type=script&lang=ts"
export * from "./CardInfo.vue?vue&type=script&lang=ts"

import "./CardInfo.vue?vue&type=style&index=0&id=8ba67392&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8ba67392"

export default script